<template>
  <div id="allorder">
    <p class="handleNav">
      <span class="name1">商品信息</span>
      <span class="name2">单价</span>
      <span class="name3">数量</span>
      <span class="name4">合计</span>
      <span class="name5">订单状态</span>
      <span class="name6">操作</span>
    </p>
    <!-- <div class="empty">  <img src="/static/img/code.png" alt=""> <p>暂无订单哦~</p></div> -->
    <ul>
      <li>
        <p class="infotop">
          <span class="orderTime">下单时间：59598</span>
          <span class="orderNo">订单号：1454</span>
        </p>
      </li>
    </ul>
    <div style="margin: 15px 0 25px 0;text-align: right" class="block">
      <el-pagination layout="pager" :total="100" :page-size="5" prev-text="1" next-text="2"></el-pagination>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  }
};
</script>

<style lang="less" scoped>
#allorder {
  border: 1px solid #e3e3e3;
  .handleNav {
    height: 38px;
    background: #f3f3f3;
    span {
      display: inline-block;
      height: 40px;
      line-height: 40px;
      text-align: center;
    }
    .name1 {
      width: 350px;
      margin-left: 20px;
      text-align: left;
    }
    .name2 {
      width: 120px;
    }
    .name3 {
      width: 100px;
    }
    .name4 {
      width: 120px;
    }
    .name5 {
      width: 100px;
    }
    .name6 {
      width: 100px;
    }
  }
  ul {
    li {
      .infotop {
        height: 41px;
        line-height: 41px;
        border-bottom: 1px dashed #ddd;
        border-bottom: none;
        padding: 0 40px 0 20px;
        overflow: hidden;
        .orderTime {
          display: inline-block;
          width: 230px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/user/cont/Orderlist.vue